import { Component } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Store } from "@ngrx/store";
import { RootState } from "src/app/store";
import { LoadingController } from "@ionic/angular";
import { IframePage } from "../iframe/iframe.page";
import { filter, first } from "rxjs/operators";

@Component({
  selector: "app-book-check-up",
  templateUrl: "../iframe/iframe.page.html",
  styleUrls: ["../iframe/iframe.page.scss"],
})
export class BookCheckUpPage extends IframePage {
  constructor(protected _store: Store<RootState>, protected _loadingController: LoadingController, private sanitizer: DomSanitizer) {
    super(_store, _loadingController);
    this.title = "Check-Up buchen";
    this.user$
      .pipe(
        filter(user => !!user),
        first(),
      )
      .subscribe(user => {
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
          `https://go.oncehub.com/wow-family-checkup?email=${user.email}&name=${user.firstName}%20${user.lastName}&customer_id=${user.id}`,
        );
      });
  }
}
